/* cvn-announcement-bar.js — lifted verbatim out of sections/announcement-bar.liquid on 2026-09-25 (theme audit v77).
   It used to be an inline <script> re-sent with every page; as an asset it is minified by the CDN and cached.
   Execution point is unchanged: the snippet loads it (blocking, no defer) exactly where the block was. */
  // cvn: announcement "join the list" CTA — smooth-scroll to the footer
  // newsletter form and focus the email field. Lives in the header group,
  // so it binds once per hard load and survives the theme's soft navigation.
  (function () {
    if (window.cvnJoinScrollBound) return;
    window.cvnJoinScrollBound = true;

    /* ⚠ A ONE-SLIDE CAROUSEL MUST STOP ROTATING, NOT JUST LOSE ITS ARROWS.
       Removing the join slide leaves the bar with a single message, and hiding
       the prev/next buttons made it LOOK settled while Dawn's SlideshowComponent
       kept its `setInterval` running underneath — every `data-speed` seconds it
       re-ran `applyAnimationToAnnouncementBar` on the one remaining slide, so
       "Free US Shipping for orders $100+" slid in again and again as though a
       second announcement were arriving. Nothing errored; the bar simply
       twitched forever for every subscriber.
       ⚠ THE ORDER OF THE TWO FIXES MATTERS. `data-autoplay="false"` is read by
       the component in its constructor, so setting it HERE — this script is
       inline in the header group and runs during parse, before the deferred
       slider asset upgrades the element — stops the interval being created at
       all. The clearInterval below is the belt for the case where the component
       has already upgraded (a re-render, or a slower parse), which is why it
       runs again on DOMContentLoaded: by then `comp.autoplay` holds the real
       timer id and can actually be cancelled.
       ⚠ CLEARING THE INTERVAL IS NOT ENOUGH ON ITS OWN. `setAutoPlay` binds
       mouseover/mouseleave/focusin/focusout on the component, and BOTH
       `focusInHandling` and `focusOutHandling` call `this.play()` — which does
       `setInterval` again. So on the already-upgraded path a single hover over
       the bar would restart the rotation we just stopped, and the bug would
       look intermittent rather than fixed. Shadowing `play` with a no-op ON
       THE INSTANCE closes every one of those paths at once without touching
       the prototype, so a bar that legitimately has two slides is unaffected. */
    var quietSingleAnnouncement = function () {
      var slider = document.querySelector('.announcement-bar-slider');
      if (!slider) return;
      if (slider.querySelectorAll('.slideshow__slide').length >= 2) return;
      slider.querySelectorAll('.slider-button').forEach(function (button) {
        button.style.display = 'none';
      });
      var track = slider.querySelector('.slider');
      if (track) track.setAttribute('data-autoplay', 'false');
      var comp = slider.closest('slideshow-component');
      if (!comp) return;
      comp.play = function () {};
      comp.autoplayButtonIsSetToPlay = false;
      try { if (typeof comp.pause === 'function') comp.pause(); } catch (e) {}
      if (typeof comp.autoplay === 'number') {
        clearInterval(comp.autoplay);
        comp.autoplay = null;
      }
    };

    // A visitor who has joined the list no longer sees the join slide.
    try {
      if (localStorage.getItem('cvn_joined') === '1' || localStorage.getItem('cvn_sf_joined') === '1') {
        document.querySelectorAll('.announcement-bar-section a[href$="#ContactFooter"]').forEach(function (link) {
          var slide = link.closest('.slideshow__slide') || link.closest('.announcement-bar');
          if (slide) slide.remove();
        });
        quietSingleAnnouncement();
        document.addEventListener('DOMContentLoaded', quietSingleAnnouncement);
      }
    } catch (e) {}

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href$="#ContactFooter"]');
      if (!link) return;
      var form = document.getElementById('ContactFooter');
      if (!form) return;
      event.preventDefault();
      var input = form.querySelector('input[type="email"]');
      if (input) input.focus({ preventScroll: true });
      var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      form.scrollIntoView({ behavior: behavior, block: 'center' });
    });
  })();
